/**
 * Shared denomination and document type options.
 * Single source of truth for dropdown menus across the app.
 */

export const DENOMINATIONS = [
  { value: 'cogic', label: 'Church of God in Christ (COGIC)' },
  { value: 'catholic', label: 'Roman Catholic Church' },
  { value: 'nondenominational', label: 'Nondenominational Evangelical' },
  { value: 'southern_baptist', label: 'Southern Baptist Convention (SBC)' },
  { value: 'united_methodist', label: 'United Methodist Church (UMC)' },
  { value: 'national_baptist', label: 'National Baptist Convention (NBC)' },
  { value: 'assemblies_of_god', label: 'Assemblies of God' },
  { value: 'lutheran_elca', label: 'Evangelical Lutheran Church in America (ELCA)' },
  { value: 'lutheran_lcms', label: 'Lutheran Church—Missouri Synod (LCMS)' },
  { value: 'presbyterian', label: 'Presbyterian Church (USA)' },
];

export const DOCUMENT_TYPES = [
  { value: '', label: 'None' },
  { value: 'articles_of_religion', label: 'Articles of Religion' },
  { value: 'book_of_concord', label: 'Book of Concord' },
  { value: 'book_of_order', label: 'Book of Order' },
  { value: 'bylaws', label: 'Bylaws' },
  { value: 'catechism', label: 'Catechism' },
  { value: 'confession_of_faith', label: 'Confession of Faith' },
  { value: 'constitution', label: 'Constitution' },
  { value: 'creed', label: 'Creed' },
  { value: 'discipline', label: 'Discipline' },
  { value: 'doctrine', label: 'Doctrine' },
  { value: 'official_manual', label: 'Official Manual' },
  { value: 'statement_of_faith', label: 'Statement of Faith' },
  { value: 'teaching', label: 'Teaching' },
];

/** Denomination abbreviation map for display labels */
export const DENOMINATION_ABBREVIATIONS: Record<string, string> = {
  'church_of_god_in_christ': 'COGIC',
  'cogic': 'COGIC',
  'southern_baptist': 'SBC',
  'catholic': 'Catholic',
  'lutheran': 'Lutheran',
  'methodist': 'Methodist',
  'presbyterian': 'Presbyterian',
  'pentecostal': 'Pentecostal',
  'episcopal': 'Episcopal',
  'reformed': 'Reformed',
  'baptist': 'Baptist',
  'orthodox': 'Orthodox',
};

export function getDenominationAbbreviation(denomination?: string): string {
  if (!denomination) return '';
  return DENOMINATION_ABBREVIATIONS[denomination.toLowerCase()] || denomination;
}
